import { jsxs as r, Fragment as g, jsx as t } from "react/jsx-runtime";
import { c as tt } from "react/compiler-runtime";
import { useState as I, useRef as nt, useEffect as je } from "react";
import { Select as ot, MenuItem as Ve, Checkbox as rt, Link as Ie, CircularProgress as ze } from "@mui/material";
import { Box as h } from "../../atoms/Box/Box.js";
import { Button as Be } from "../../atoms/Button/Button.js";
import { Grid as w } from "../../atoms/Grid/Grid.js";
import { I as Ae } from "../../../chunks/Map.js";
import { Typography as a } from "../../atoms/Typography/Typography.js";
import { l as it, a as at } from "../../../chunks/login_page_background.js";
import Ne from "@mui/icons-material/ArrowForward";
import lt from "../../../assets/icons/SignInGoogleIcon.js";
import st from "../../../assets/icons/SignInMicrosoftIcon.js";
import ct from "../../../assets/icons/SignInCustomIcon.js";
const jt = (n) => {
  const e = tt(115), {
    errorsComponent: X,
    loading: s,
    onLogin: x,
    onNext: De,
    onBackToLogin: Oe,
    onForgotPassword: Le,
    onLicenseAgreement: ne,
    hidePassword: Ge,
    authProviders: oe,
    lastUsedEmail: $e,
    usernameLocked: qe,
    handleSwitchUser: He,
    show2FAInput: Ye,
    configFor2FA: o
  } = n, A = Ge === void 0 ? !0 : Ge;
  let re;
  e[0] !== oe ? (re = oe === void 0 ? [] : oe, e[0] = oe, e[1] = re) : re = e[1];
  const B = re, ie = $e === void 0 ? "" : $e, J = qe === void 0 ? !1 : qe, _e = He === void 0 ? mt : He, p = Ye === void 0 ? !1 : Ye, [u, Xe] = I(ie), [y, Je] = I("");
  let ae;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ae = ["", "", "", "", "", ""], e[2] = ae) : ae = e[2];
  const [T, Z] = I(ae), [c, ee] = I(0);
  let le;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (le = [], e[3] = le) : le = e[3];
  const N = nt(le), [S, Ke] = I(""), [v, Qe] = I(""), [k, Ze] = I(!1);
  let se, ce;
  e[4] !== o ? (se = () => {
    o?.countryCode && Ke(o.countryCode), o?.phoneNumber && Qe(o.phoneNumber);
  }, ce = [o], e[4] = o, e[5] = se, e[6] = ce) : (se = e[5], ce = e[6]), je(se, ce);
  let me, de;
  e[7] !== p ? (me = () => {
    if (!p) {
      ee(0);
      return;
    }
    ee(60);
  }, de = [p], e[7] = p, e[8] = me, e[9] = de) : (me = e[8], de = e[9]), je(me, de);
  let pe, ue;
  e[10] !== c || e[11] !== p ? (pe = () => {
    if (!p || c <= 0)
      return;
    const E = window.setInterval(() => {
      ee(dt);
    }, 1e3);
    return () => window.clearInterval(E);
  }, ue = [p, c], e[10] = c, e[11] = p, e[12] = pe, e[13] = ue) : (pe = e[12], ue = e[13]), je(pe, ue);
  let he;
  e[14] !== o?.otpTargets ? (he = o?.otpTargets ?? [], e[14] = o?.otpTargets, e[15] = he) : he = e[15];
  const f = he;
  let ge;
  e[16] !== o?.maskedPhoneNumber || e[17] !== f ? (ge = f.includes("SMS") && !!o?.maskedPhoneNumber, e[16] = o?.maskedPhoneNumber, e[17] = f, e[18] = ge) : ge = e[18];
  const fe = ge;
  let xe;
  e[19] !== o?.maskedEmail || e[20] !== f ? (xe = f.includes("EMAIL") && !!o?.maskedEmail, e[19] = o?.maskedEmail, e[20] = f, e[21] = xe) : xe = e[21];
  const ye = xe, b = o?.status === "FAILED_TOO_FREQUENT", D = o?.status === "CONSENT_REQUIRED";
  let be;
  e[22] !== o?.status || e[23] !== f ? (be = o?.status === "MISSING_PHONE_NUMBER" && f.includes("SMS"), e[22] = o?.status, e[23] = f, e[24] = be) : be = e[24];
  const we = be, F = !we;
  let Te;
  e[25] !== Oe ? (Te = function() {
    Z(["", "", "", "", "", ""]), ee(0), Oe?.();
  }, e[25] = Oe, e[26] = Te) : Te = e[26];
  const Re = Te;
  let Fe;
  e[27] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Fe = function(Q) {
    const C = Math.floor(Q / 60).toString().padStart(2, "0"), Ue = Math.floor(Q % 60).toString().padStart(2, "0");
    return `${C}:${Ue}`;
  }, e[27] = Fe) : Fe = e[27];
  const et = Fe;
  let Ce;
  e[28] !== u || e[29] !== x || e[30] !== y || e[31] !== c ? (Ce = async function() {
    c > 0 || x && (Z(["", "", "", "", "", ""]), x(u.trim(), y.trim()), ee(60));
  }, e[28] = u, e[29] = x, e[30] = y, e[31] = c, e[32] = Ce) : Ce = e[32];
  const Me = Ce;
  let Se;
  e[33] !== F || e[34] !== k || e[35] !== S || e[36] !== u || e[37] !== A || e[38] !== D || e[39] !== b || e[40] !== x || e[41] !== De || e[42] !== T || e[43] !== y || e[44] !== v || e[45] !== p ? (Se = function(Q) {
    if (Q?.preventDefault(), p) {
      if (b || !F)
        return;
      if (D) {
        if (!k || !S || !v)
          return;
        x && x(u.trim(), y.trim(), void 0, k, S, v);
        return;
      }
      const C = T.join("");
      if (C.length !== 6)
        return;
      x && (x(u.trim(), y.trim(), C), Z(["", "", "", "", "", ""]));
      return;
    }
    A ? De?.(u) : x(u.trim(), y.trim());
  }, e[33] = F, e[34] = k, e[35] = S, e[36] = u, e[37] = A, e[38] = D, e[39] = b, e[40] = x, e[41] = De, e[42] = T, e[43] = y, e[44] = v, e[45] = p, e[46] = Se) : Se = e[46];
  const We = Se;
  let O, L, _, R, M, W, U, j, z, P, G, $, q;
  if (e[47] !== B || e[48] !== F || e[49] !== o?.countryCode || e[50] !== o?.maskedEmail || e[51] !== o?.maskedPhoneNumber || e[52] !== o?.status || e[53] !== k || e[54] !== S || e[55] !== u || e[56] !== X || e[57] !== Me || e[58] !== We || e[59] !== _e || e[60] !== ye || e[61] !== fe || e[62] !== A || e[63] !== D || e[64] !== b || e[65] !== ie || e[66] !== s || e[67] !== Le || e[68] !== ne || e[69] !== T || e[70] !== f.length || e[71] !== y || e[72] !== v || e[73] !== c || e[74] !== Re || e[75] !== we || e[76] !== p || e[77] !== J) {
    const E = function(l, m) {
      const V = m.replace(/\D/g, "").slice(0, 1);
      if (V === "" && m !== "")
        return;
      const Ee = [...T];
      Ee[l] = V, Z(Ee), V && l < 5 && N.current[l + 1]?.focus();
    }, Q = function(l, m) {
      m.key === "Backspace" && !T[l] && l > 0 && N.current[l - 1]?.focus(), m.key === "ArrowLeft" && l > 0 && N.current[l - 1]?.focus(), m.key === "ArrowRight" && l < 5 && N.current[l + 1]?.focus();
    };
    let C;
    e[91] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = function(l) {
      l.preventDefault();
      const m = l.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
      if (m.length > 0) {
        const V = ["", "", "", "", "", ""];
        for (let te = 0; te < m.length && te < 6; te++)
          V[te] = m[te];
        Z(V);
        const Ee = Math.min(m.length, 5);
        N.current[Ee]?.focus();
      }
    }, e[91] = C) : C = e[91];
    const Ue = C;
    R = w, $ = !0, q = i.main, _ = w, G = i.loginContainer, L = w, z = i.topContainer, e[92] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (P = /* @__PURE__ */ t(w, { sx: i.logo, children: /* @__PURE__ */ t("img", { src: at, width: "236" }) }), e[92] = P) : P = e[92], O = w, M = "form", W = We, U = i.loginForm, j = p ? D ? /* @__PURE__ */ r(g, { children: [
      /* @__PURE__ */ t(a, { sx: i.loginTitleText, color: "#141414", children: "User Consent required" }),
      /* @__PURE__ */ t(w, { sx: i.error, children: X }),
      /* @__PURE__ */ r(h, { width: "100%", display: "flex", flexDirection: "column", gap: 1, sx: {
        mb: 1
      }, children: [
        /* @__PURE__ */ t(a, { type: "bodyText1", color: "#5A5A5A", fontWeight: 500, children: "Phone Number" }),
        /* @__PURE__ */ r(h, { width: "100%", display: "flex", alignItems: "center", gap: 1, sx: {
          mb: 1
        }, children: [
          /* @__PURE__ */ r(ot, { id: "country", sx: {
            mt: "2px",
            height: "37px",
            borderRadius: "8px",
            border: "none"
          }, displayEmpty: !0, renderValue: pt, name: "Country code", value: S, onChange: (d) => Ke(d.target.value), children: [
            /* @__PURE__ */ t(Ve, { value: "+1", children: "United States (+1)" }),
            /* @__PURE__ */ t(Ve, { value: "+91", children: "India (+91)" })
          ] }),
          /* @__PURE__ */ t(Ae, { name: "phoneNumber", placeholder: "Phone Number", value: v, inputProps: {
            pattern: "[0-9]*",
            inputMode: "numeric",
            maxLength: 10
          }, onChange: (d) => Qe(d.target.value.replace(/[^0-9]/g, "").slice(0, 10)) })
        ] }),
        /* @__PURE__ */ r(h, { display: "flex", alignItems: "start", gap: 1, sx: {
          mb: 0.5
        }, children: [
          /* @__PURE__ */ t(rt, { id: "consentToUseEmailAndPhoneNumber", name: "consentToUseEmailAndPhoneNumber", value: k, onChange: (d) => Ze(d.target.checked) }),
          /* @__PURE__ */ t("label", { htmlFor: "consentToUseEmailAndPhoneNumber", style: {
            userSelect: "none"
          }, children: /* @__PURE__ */ r(a, { type: "bodyText1", color: "#878787", children: [
            "By providing my mobile number, I agree to receive one-time password (OTP) messages from Highway9 Networks for authentication and account verification purposes. I understand that message frequency may vary, message and data rates may apply. ",
            /* @__PURE__ */ t("br", {}),
            /* @__PURE__ */ t("br", {}),
            "You can reply STOP to opt out or HELP for help, if you want to change your preference later."
          ] }) })
        ] }),
        /* @__PURE__ */ r(h, { display: "flex", alignItems: "baseline", justifyContent: "center", gap: 1, sx: {
          mb: 1
        }, children: [
          /* @__PURE__ */ t(Ie, { href: "https://console.live.highway9networks.com/eula", target: "_blank", children: "Terms & Conditions" }),
          /* @__PURE__ */ t(Ie, { href: "https://console.live.highway9networks.com/sms-authentication-disclosure", target: "_blank", children: "Privacy Policy" })
        ] })
      ] }),
      /* @__PURE__ */ t(Be, { type: "submit", sx: i.loginButton, disabled: s || !k || !S || !v, children: s ? /* @__PURE__ */ r(g, { children: [
        s && /* @__PURE__ */ t(ze, { size: 24 }),
        "  "
      ] }) : /* @__PURE__ */ r(g, { children: [
        /* @__PURE__ */ t(a, { type: "heading3", color: "#FFFFFF", sx: i.loginText, children: "Submit" }),
        /* @__PURE__ */ t(Ne, {})
      ] }) })
    ] }) : /* @__PURE__ */ r(g, { children: [
      /* @__PURE__ */ t(a, { sx: i.loginTitleText, color: "#141414", children: "Two-factor authentication" }),
      /* @__PURE__ */ t(w, { sx: i.error, children: X }),
      F && !b && /* @__PURE__ */ r(a, { sx: {
        ...i.welcomeBackText,
        marginTop: "12px",
        textAlign: "center"
      }, color: "#878787", children: [
        "To ensure your account is secure, please enter the 6-digit verification code sent to your registered",
        !f.length && " channels.",
        fe ? ` phone number at ${o?.countryCode} ${o?.maskedPhoneNumber}` : "",
        fe && ye ? " or" : "",
        ye ? ` email address at ${o?.maskedEmail}` : "",
        "."
      ] }),
      F && !b && o?.status === "FAILED" && /* @__PURE__ */ r(h, { sx: {
        width: "100%",
        marginTop: "8px"
      }, children: [
        /* @__PURE__ */ t(a, { sx: {
          textAlign: "center",
          fontWeight: 500
        }, color: ut, children: "Your verification code is incorrect." }),
        /* @__PURE__ */ t(a, { sx: {
          textAlign: "center",
          marginTop: "4px"
        }, color: "#878787", children: "Please try again." })
      ] }),
      F && !b && o?.status === "EXPIRED" && /* @__PURE__ */ r(h, { sx: {
        width: "100%",
        marginTop: "8px"
      }, children: [
        /* @__PURE__ */ t(a, { sx: {
          textAlign: "center",
          fontWeight: 500
        }, color: ht, children: "Your verification code has expired." }),
        /* @__PURE__ */ t(a, { sx: {
          textAlign: "center",
          marginTop: "4px"
        }, color: "#878787", children: "Please resend the OTP and enter the new 6-digit code to continue." })
      ] }),
      b && /* @__PURE__ */ r(h, { sx: {
        width: "100%",
        marginTop: "16px",
        marginBottom: "24px"
      }, children: [
        /* @__PURE__ */ t(a, { sx: {
          textAlign: "center",
          fontWeight: 500
        }, color: gt, children: "You have been locked after multiple failed attempts." }),
        /* @__PURE__ */ t(a, { sx: {
          textAlign: "center",
          marginTop: "8px"
        }, color: "#878787", children: "Please contact your administrator." })
      ] }),
      !b && we && /* @__PURE__ */ r(h, { sx: {
        width: "100%",
        marginTop: "16px",
        marginBottom: "24px"
      }, children: [
        /* @__PURE__ */ t(a, { sx: {
          textAlign: "center",
          fontWeight: 500
        }, color: ft, children: "Two-factor authentication is enabled, but no phone number is linked." }),
        /* @__PURE__ */ t(a, { sx: {
          textAlign: "center",
          marginTop: "8px"
        }, color: "#878787", children: "Please contact your administrator to link a phone number." })
      ] }),
      !b && F && /* @__PURE__ */ r(g, { children: [
        /* @__PURE__ */ t(h, { sx: {
          width: "100%",
          marginBottom: "12px",
          marginTop: "16px",
          display: "flex",
          justifyContent: "center",
          gap: "8px"
        }, children: T.map((d, l) => /* @__PURE__ */ t(Ae, { inputRef: (m) => {
          N.current[l] = m;
        }, name: `otp-${l}`, required: !0, sx: {
          ...i.inputEmail,
          width: "48px",
          maxWidth: "48px",
          "& .MuiInputBase-input": {
            textAlign: "center",
            fontSize: "1.5rem",
            fontWeight: 500,
            padding: "8px"
          }
        }, type: "text", inputProps: {
          maxLength: 1,
          pattern: "[0-9]*",
          inputMode: "numeric"
        }, value: d, onChange: (m) => E(l, m.target.value), onKeyDown: (m) => Q(l, m), onPaste: Ue, autoFocus: l === 0 }, l)) }),
        /* @__PURE__ */ t(h, { sx: {
          width: "100%",
          marginBottom: "24px",
          display: "flex",
          justifyContent: "center"
        }, children: /* @__PURE__ */ r(Ie, { component: "button", type: "button", onClick: (d) => {
          d.preventDefault(), !(c > 0) && Me();
        }, sx: {
          fontWeight: 500,
          fontSize: "0.875rem",
          textDecoration: c > 0 ? "none" : "underline",
          color: c > 0 ? xt : yt,
          cursor: c > 0 ? "not-allowed" : "pointer",
          pointerEvents: (c > 0, "auto"),
          opacity: c > 0 ? 0.6 : 1,
          "&:hover": {
            textDecoration: c > 0 ? "none" : "underline"
          }
        }, children: [
          "Resend OTP",
          c > 0 ? ` (${et(c)})` : ""
        ] }) }),
        /* @__PURE__ */ t(Be, { type: "submit", sx: i.loginButton, disabled: s || T.join("").length !== 6, children: s ? /* @__PURE__ */ r(g, { children: [
          s && /* @__PURE__ */ t(ze, { size: 24 }),
          "  "
        ] }) : /* @__PURE__ */ r(g, { children: [
          /* @__PURE__ */ t(a, { type: "heading3", color: "#FFFFFF", sx: i.loginText, children: "Submit" }),
          /* @__PURE__ */ t(Ne, {})
        ] }) }),
        /* @__PURE__ */ t(h, { sx: {
          width: "100%",
          marginBottom: "24px",
          display: "flex",
          justifyContent: "center"
        }, children: /* @__PURE__ */ t(Ie, { component: "button", type: "button", onClick: Re, disabled: s, sx: {
          fontWeight: 500,
          fontSize: "0.875rem",
          textDecoration: s ? "none" : "underline",
          color: s ? bt : wt,
          cursor: s ? "not-allowed" : "pointer",
          pointerEvents: "auto",
          opacity: s ? 0.6 : 1,
          "&:hover": {
            textDecoration: s ? "none" : "underline"
          }
        }, children: "Back to Login" }) })
      ] })
    ] }) : /* @__PURE__ */ r(g, { children: [
      /* @__PURE__ */ t(a, { sx: i.welcomeBackText, color: "#878787", children: "Welcome back," }),
      /* @__PURE__ */ t(a, { sx: i.loginTitleText, color: "#141414", children: "Log in to your account" }),
      /* @__PURE__ */ t(w, { sx: i.error, children: X }),
      /* @__PURE__ */ r(h, { sx: {
        width: "100%",
        marginBottom: J ? "0px" : "24px",
        marginTop: "12px"
      }, children: [
        /* @__PURE__ */ t(Ae, { label: "Email", name: "email", id: "username", placeholder: "Email", disabled: J, sx: i.inputEmail, type: "email", value: u && u.trim() != "" ? u : ie, onChange: (d) => Xe(d.target.value), autoFocus: !0 }),
        J && /* @__PURE__ */ t(h, { component: "span", onClick: _e, sx: {
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "4px",
          cursor: "pointer",
          fontSize: "0.75rem",
          color: Tt,
          textDecoration: "none",
          fontWeight: 500,
          "&:hover": {
            textDecoration: "underline"
          }
        }, children: "Change User" })
      ] }),
      !A && /* @__PURE__ */ t(Ae, { label: "Password", id: "password", name: "password", type: "password", placeholder: "Password", autoFocus: !0, sx: i.inputPass, value: y, onChange: (d) => Je(d.target.value) }),
      B.length == 0 && /* @__PURE__ */ t(Be, { type: "submit", sx: i.loginButton, disabled: s, children: s ? /* @__PURE__ */ r(g, { children: [
        s && /* @__PURE__ */ t(ze, { size: 24 }),
        "  "
      ] }) : /* @__PURE__ */ r(g, { children: [
        /* @__PURE__ */ t(a, { type: "heading3", color: "#FFFFFF", sx: i.loginText, children: "Log In" }),
        /* @__PURE__ */ t(Ne, { sx: {
          color: "#FFFFFF"
        } })
      ] }) }),
      B.length > 0 && /* @__PURE__ */ t(w, { container: !0, spacing: 2, children: B.map(Ft) }),
      /* @__PURE__ */ r("div", { style: i.actions, children: [
        B.length == 0 && /* @__PURE__ */ t("div", { onClick: () => Le?.(), children: /* @__PURE__ */ t(a, { type: "heading3", sx: {
          ...i.pointer,
          fontWeight: 500,
          color: Ct
        }, children: "Forgot/Reset Password" }) }),
        !!ne && /* @__PURE__ */ t("div", { onClick: () => ne?.(), children: /* @__PURE__ */ t(a, { type: "heading3", sx: {
          ...i.pointer,
          fontWeight: 500,
          color: St
        }, children: "License Agreement" }) })
      ] })
    ] }), e[47] = B, e[48] = F, e[49] = o?.countryCode, e[50] = o?.maskedEmail, e[51] = o?.maskedPhoneNumber, e[52] = o?.status, e[53] = k, e[54] = S, e[55] = u, e[56] = X, e[57] = Me, e[58] = We, e[59] = _e, e[60] = ye, e[61] = fe, e[62] = A, e[63] = D, e[64] = b, e[65] = ie, e[66] = s, e[67] = Le, e[68] = ne, e[69] = T, e[70] = f.length, e[71] = y, e[72] = v, e[73] = c, e[74] = Re, e[75] = we, e[76] = p, e[77] = J, e[78] = O, e[79] = L, e[80] = _, e[81] = R, e[82] = M, e[83] = W, e[84] = U, e[85] = j, e[86] = z, e[87] = P, e[88] = G, e[89] = $, e[90] = q;
  } else
    O = e[78], L = e[79], _ = e[80], R = e[81], M = e[82], W = e[83], U = e[84], j = e[85], z = e[86], P = e[87], G = e[88], $ = e[89], q = e[90];
  let H;
  e[93] !== O || e[94] !== M || e[95] !== W || e[96] !== U || e[97] !== j ? (H = /* @__PURE__ */ t(O, { component: M, onSubmit: W, sx: U, children: j }), e[93] = O, e[94] = M, e[95] = W, e[96] = U, e[97] = j, e[98] = H) : H = e[98];
  let Y;
  e[99] !== L || e[100] !== z || e[101] !== P || e[102] !== H ? (Y = /* @__PURE__ */ r(L, { sx: z, children: [
    P,
    H
  ] }), e[99] = L, e[100] = z, e[101] = P, e[102] = H, e[103] = Y) : Y = e[103];
  let ve;
  e[104] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ve = /* @__PURE__ */ t(a, { type: "heading4", color: "#141414", sx: {
    fontWeight: 400
  }, children: "Don’t have an account?" }), e[104] = ve) : ve = e[104];
  let ke;
  e[105] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ke = /* @__PURE__ */ r(w, { sx: i.noAccount, children: [
    ve,
    /* @__PURE__ */ t("div", { onClick: vt, children: /* @__PURE__ */ t(a, { type: "heading3", sx: {
      color: kt,
      ...i.pointer
    }, children: "Contact Support" }) })
  ] }), e[105] = ke) : ke = e[105];
  let K;
  e[106] !== _ || e[107] !== G || e[108] !== Y ? (K = /* @__PURE__ */ r(_, { sx: G, children: [
    Y,
    ke
  ] }), e[106] = _, e[107] = G, e[108] = Y, e[109] = K) : K = e[109];
  let Pe;
  return e[110] !== R || e[111] !== $ || e[112] !== q || e[113] !== K ? (Pe = /* @__PURE__ */ t(R, { container: $, sx: q, children: K }), e[110] = R, e[111] = $, e[112] = q, e[113] = K, e[114] = Pe) : Pe = e[114], Pe;
}, i = {
  main: (n) => ({
    width: "100vw",
    height: "100vh",
    overflow: "none",
    backgroundColor: n.vars?.palette.primary.main ?? n.palette.primary.main,
    backgroundImage: `url("${it}")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
  }),
  logo: {
    textAlign: "center",
    marginBottom: "40px"
  },
  loginContainer: {
    backgroundColor: "#FFFFFF",
    borderRadius: "24px",
    width: "100%",
    mx: "8px",
    maxHeight: "95vh",
    maxWidth: "500px"
  },
  topContainer: {
    padding: "3rem 3.5rem 2rem"
  },
  loginForm: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
  },
  actions: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    flexDirection: "column",
    gap: "8px"
  },
  noAccount: {
    borderTop: "1px solid #EFEFEF",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    py: "32px",
    gap: "8px"
  },
  pointer: {
    cursor: "pointer"
  },
  loginButton: {
    backgroundColor: (n) => n?.vars?.palette?.primary?.main ?? n?.palette?.primary?.main,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "40px",
    width: "100%",
    marginBottom: "16px",
    "&::before ": {
      content: "''",
      width: 0
    }
  },
  welcomeBackText: {
    fontSize: "1rem",
    marginBottom: "8px"
  },
  loginTitleText: {
    fontWeight: 500,
    fontSize: "1.25rem",
    marginBottom: "8px"
  },
  loginText: {
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    gap: "8px"
  },
  inputEmail: {
    marginTop: 0,
    marginBottom: 0
  },
  inputPass: {
    // marginTop: "12px",
    marginBottom: "24px"
  },
  error: {
    marginBottom: "1rem",
    marginTop: "0.5rem",
    width: "100%",
    "& .MuiAlert-root": {
      borderRadius: "8px"
    }
  }
};
function mt() {
}
function dt(n) {
  return Math.max(0, n - 1);
}
function pt(n) {
  return n || "Code";
}
function ut(n) {
  return n.palette.error.main;
}
function ht(n) {
  return n.palette.error.main;
}
function gt(n) {
  return n.palette.error.main;
}
function ft(n) {
  return n.palette.warning.main;
}
function xt(n) {
  return n.palette.grey[500];
}
function yt(n) {
  return n.palette.primary.main;
}
function bt(n) {
  return n.palette.grey[500];
}
function wt(n) {
  return n.palette.primary.main;
}
function Tt(n) {
  return n.palette.primary.main;
}
function Ft(n) {
  return /* @__PURE__ */ t(w, { size: {
    xs: 12
  }, children: /* @__PURE__ */ r(Be, { type: "button", sx: i.loginButton, onClick: () => window.location.href = n.redirectUrl, children: [
    /* @__PURE__ */ r(a, { type: "heading3", color: "#FFFFFF", sx: i.loginText, children: [
      n.oidcName === "GOOGLE" && /* @__PURE__ */ r(g, { children: [
        /* @__PURE__ */ t(lt, {}),
        "   Sign in with Google"
      ] }),
      n.oidcName === "MICROSOFT" && /* @__PURE__ */ r(g, { children: [
        /* @__PURE__ */ t(st, {}),
        "   Sign in with Microsoft"
      ] }),
      n.oidcName != "GOOGLE" && n.oidcName != "MICROSOFT" && /* @__PURE__ */ r(g, { children: [
        /* @__PURE__ */ t(ct, {}),
        "   Sign in with ",
        n.oidcName
      ] })
    ] }),
    /* @__PURE__ */ t(Ne, {})
  ] }) }, n.oidcName);
}
function Ct(n) {
  return n.palette.grey[600];
}
function St(n) {
  return n.palette.primary.main;
}
function vt() {
  return window.open("mailto:support@highway9.com");
}
function kt(n) {
  return n.vars?.palette.primary.main;
}
export {
  jt as default
};
